import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppFirstDetails from 'src/components/details/customer-details/AppFirstDetails'
import AppSecondDetails from 'src/components/details/customer-details/AppSecondDetails'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// helpers
import Axios from 'src/helpers/axios'

const CustomerDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params

  const [customerDetails, setCustomerDetails] = useState('')
  const [shippingAddressDetails, setShippingAddressDetails] = useState('')
  const [customerPurchaseHistory, setCustomerPurchaseHistory] = useState([])
  const [customerWishlist, setCustomerWishlist] = useState([])
  const [customerShoppingCart, setCustomerShoppingCart] = useState([])
  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  useEffect(() => {
    fetchCustomerDetails(id)
  }, [id]);

  const fetchCustomerDetails = async (id) => {
    Axios({
      method: "get",
      url: `/api/sso/v1/users/id/${id}`,
    })
      .then(({ data }) => {
        setCustomerDetails(data)
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        fetchCustomerPurchaseHistory(id)
        fetchCustomerWishlist(id)
        fetchCustomerShoppingCart(id)
        fetchShippingAddressDetails(id)
      })
  }

  const fetchCustomerPurchaseHistory = async (id) => {
    Axios({
      method: "post",
      url: `/api/ecommerce/v1/transactions/user/id/${id}`,
      data: {
        order: ['createdAt', 'desc']
      }
    })
      .then(({ data }) => {
        setCustomerPurchaseHistory(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const fetchCustomerWishlist = async (id) => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/wishlist/user/id/${id}`,
    })
      .then(({ data }) => {
        setCustomerWishlist(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const fetchCustomerShoppingCart = async (id) => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/carts/user/id/${id}`,
    })
      .then(({ data }) => {
        setCustomerShoppingCart(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const fetchShippingAddressDetails = async (id) => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/shippingaddress/customer/id/${id}`,
    })
      .then(({ data }) => {
        setShippingAddressDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const handleDeleteConfirmation = (item) => {
    Axios({
      method: "delete",
      url: `/api/ecommerce/v1/customers/${item.id}`,
    })
      .then(({ data }) => {
        setShowConfirmDelete({ show: false, item: {} })
        navigate(`/customers/list`)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <>
      {showConfirmDelete.show && (
        <AppModalConfirmation
          confirmationType='delete-item'
          itemName='customer'
          itemDetails={showConfirmDelete.item}
          showModal={showConfirmDelete}
          setShowModal={setShowConfirmDelete}
          handleConfirmation={handleDeleteConfirmation}
        />
      )}
      <AppCard
        className='mb-4'
        headerTitle={
          <AppCardHeader
            id={id}
            headerDeleteButton={true}
            setShowConfirmDelete={setShowConfirmDelete}
            headerTitle={<h4>Customer Details</h4>}
            headerButton="VERIFIED"
          />
        }
        bodyContent={
          <AppFirstDetails
            customerDetails={customerDetails}
            shippingAddressDetails={shippingAddressDetails}
          />
        }
        lowerBodyContent={
          <AppSecondDetails
            customerDetails={customerDetails}
            customerPurchaseHistory={customerPurchaseHistory}
            customerWishlist={customerWishlist}
            customerShoppingCart={customerShoppingCart}
          />
        }
      />
    </>
  )
}

export default CustomerDetails
